module.exports = __webpack_public_path__ + "button-remove.svg?002d2305dd43521f0609fdeb022b3fde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-remove.svg
// module id = 202
// module chunks = 0